import { QueryClient } from '@tanstack/react-query';

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 1,
      // Refetch when the WebView regains focus (user returns to the Mini App
      // after switching chats, or the app comes back from background).
      refetchOnWindowFocus: true,
      refetchOnReconnect: true,
      // Treat data as stale quickly so focus-refetches actually hit the network.
      staleTime: 15_000,
    },
    mutations: { retry: 0 },
  },
});
